export default __webpack_public_path__ + "static/media/april-2017-school-day.6f3d79df.csv";